class SentQueriesController {
    constructor($scope, DTOptionsBuilder, DTColumnBuilder, USER,
        CONST, materialButtons, datePicker, $rootScope, $timeout, QueryModalOptions, FunctionService) {

        this.datatableApi;
        this.user = USER;
        this.name = 'Sent Queries';
        this.separationString = '';
        this.locale = 'en-au';
        this.url = WEBSERVICEURL + '/dataagility/api/service.sentqueries';
        this.initUrl = this.url + '?startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L');
        this.totalProjectedWiesDifference = 0;

        materialButtons.render();
        materialButtons.processing();

        FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
            function (response) {
                $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
            }
        );

        $scope.initCallback = function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Datatables has finished init
            // Initialise searching
            if ($scope.vm.datatableApi)
                return;

            $scope.vm.datatableApi = this.api();

            // Update column headers even when no data returned
            setDtHeaders($scope.vm.datatableApi);

            // setup search filters
            search();
            // set the table to a fixed height, so it never collapsed up and down
            $('#auditTable').closest('.dataTables_scrollBody').height(300);
        }

        $scope.drawCallback = function (nRow) {
            // tell DataTables we're using Aussie-formatted dates for ordering
            $.fn.dataTable.moment('DD/MM/YYYY');
            $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
        }

        this.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                url: $scope.vm.initUrl,
                type: 'GET',
                error: (xhr, error, thrown) => {
                    if (thrown == 'Unauthorized') window.location.replace(window.location.origin + '/login');
                }
            })
            .withDisplayLength(CONST.TABLEROWS)
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('sAjaxDataProp', '')
            .withOption('bLengthChange', false)
            .withPaginationType('simple_numbers')
            .withOption('rowCallback', function (row, data, index) {
                // Update column headers if data returned
                setDtHeaders($('#auditTable').DataTable());
            })
            .withOption('rowCallback', $scope.rowCallback)
            .withOption('drawCallback', $scope.drawCallback)
            .withOption('initComplete', $scope.initCallback)
            .withOption('scrollY', '300px')
            .withOption('scrollX', 'auto')
            .withOption('aaSorting', [
                [2, 'asc']
            ])
            .withOption('dom', '<"wrapper"rt<"table-footer"iBp>>')
            .withButtons([
                {
                    extend: 'print',
                    text: ''
                }, {
                    extend: 'csvHtml5',
                    text: '',
                    filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
                }, {
                    extend: 'excelHtml5',
                    text: '',
                    filename: $scope.vm.name + "-" + moment().format('YYYYMMDD-HHmm')
                }, {
                    text: '',
                    action: function (e, dt, node, config) {
                        dt.ajax.reload();
                    }
                }
            ]);

        this.dtColumns = [
            DTColumnBuilder.newColumn('episodeQueryId').withTitle('Query ID').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('urn').withTitle('UR Number').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('admissionDate').withOption('defaultContent', '').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('dischargeDate').withOption('defaultContent', '').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('sentDate').withTitle('Sent Date').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric').renderWith(function(data, type, full) {
                return moment(data).format('DD/MM/YYYY HH:mm');
            }),
            DTColumnBuilder.newColumn('sentBy').withTitle('Sent By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryStatus').withTitle('Query Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')
        ];

        // Search filters
        this.searchFilter = '';
        this.queryStatus = {
            selectedQueryStatus: []
        };
        this.queryStatusOptions = [];

        QueryModalOptions.statuses().then(
            function successCallback(response) {
                angular.forEach(response, function (value, key) {
                    if ($scope.vm.queryStatusOptions.indexOf(value.name) === -1)
                        $scope.vm.queryStatusOptions.push(value.name);
                });
            }
        );

        this.startDatePicker = {
            input: {
                date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
                dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
            }
        };
        this.endDatePicker = {
            input: {
                date: moment().locale(this.locale).subtract(1, 'days'),
                dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
            }
        };

        // callbacks for lx-selects and lx-date-picker
        datePicker.autoClose($scope);
        this.filterCallback = filterCallback;

        function filterQueryStatus(swap) {
            // query status
            $scope.vm.queryStatus.selectedQueryStatus = [];

            if (swap !== 'minus') {
                angular.forEach($scope.vm.queryStatusOptions, function(value, key) {
                    $scope.vm.queryStatus.selectedQueryStatus.push($scope.vm.queryStatusOptions[$scope.vm.queryStatusOptions.indexOf(value)]);
                });
            }
        }

        function filterCallback(_newValue, _oldValue) {
            $scope.vm.changeData();
        }

        function checkParam(param) {
            if (param.length !== 0) {
                return encodeURIComponent(param.join());
            } else {
                return '';
            }
        }

        this.changeData = changeData;

        function changeData() {
            var newUrl = $scope.vm.url
                         + '?startDate=' + $scope.vm.startDatePicker.input.dateFormatted
                         + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted
                         + '&queryStatus=' + checkParam($scope.vm.queryStatus.selectedQueryStatus)
                         + '&search=' + $scope.vm.searchFilter;
            $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
        }

        function setDtHeaders(table) {
            $(table.column(3).header()).html($scope.vm.separationString + ' Date');
        }

        function search() {
            var timeoutPromise,
                delayInMs = 500;

            $scope.$watch("vm.searchFilter", function(searchString, oldvalue) {
                $timeout.cancel(timeoutPromise); // Does nothing if timeout already done
                timeoutPromise = $timeout(function() { // Set timeout
                    if (searchString !== oldvalue) {
                        $scope.vm.changeData();
                    }
                },delayInMs);
            });

            // delete any global searches previously applied
            if ($.fn.dataTable.ext.search.length === 1)
                $.fn.dataTable.ext.search.shift();

            filterQueryStatus('minus');

            // re-draw tabele on datepicker close
            $scope.$on('lx-date-picker__close-start', function(e, id) {
                $scope.vm.changeData();
            });
        }

        // bind the datatable instance to an object to monitor loading
        this.dtInstanceCallback = dtInstanceCallback;

        function dtInstanceCallback(dtInstance) {
            $scope.dtInstance = dtInstance._renderer;
        }

        // bind filter swap
        this.filterSwap = filterSwap;

        function filterSwap(thisFilter, thisModifier) {
            switch (thisFilter) {
                case 'queryStatus':
                    if (thisModifier === 'add') {
                        filterQueryStatus('add');
                    } else {
                        filterQueryStatus('minus');
                    }
                    break;
                default:
                    break;
            }
        }
    }
}

export default SentQueriesController;



// WEBPACK FOOTER //
// ./client/app/common/reports/sentqueries/sentqueries.controller.js